import React from 'react'
import jMoment from 'moment-jalaali'

import { DatePickerInput } from '.'
import { isRtl } from '../../../settings'
import CustomizedDateInput from './CustomizedDateInput'
import { DateAndTimePicker } from './DateAndTimePicker'

class DateInput extends React.Component {
  state = {
    isLoading: isRtl,
  }
  componentDidMount = () => {
    if (isRtl) {
      jMoment.loadPersian({
        dialect: 'persian-modern',
        usePersianDigits: false,
      })
      this.setState({ isLoading: false })
    }
  }
  render() {
    if (this.state.isLoading) return null
    if (this.props.dateTimePicker) return <DateAndTimePicker {...this.props} />
    return this.props.customized ? (
      <CustomizedDateInput {...this.props} />
    ) : (
      <DatePickerInput {...this.props} />
    )
  }
}

export default DateInput
